import { render, staticRenderFns } from "./MenuListIcon.vue?vue&type=template&id=1146f70f&"
import script from "./MenuListIcon.vue?vue&type=script&lang=js&"
export * from "./MenuListIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports